import { Button, ButtonProps } from '@mui/material'
import useSubmitLock from 'hooks/use-submit-lock'

const disabledSx = {
  '&.Mui-disabled': {
    bgcolor: 'action.disabledBackground',
    color: 'action.disabled',
  },
}

const SubmitLockButton = ({
  onClick,
  disabled,
  sx,
  children,
  ...rest
}: ButtonProps) => {
  const { isSubmitting, wrapClick } = useSubmitLock()
  const isDisabled = !!disabled || isSubmitting

  return (
    <Button
      {...rest}
      disabled={isDisabled}
      onClick={wrapClick(onClick)}
      sx={[disabledSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    >
      {children}
    </Button>
  )
}

export default SubmitLockButton
